import { Task, TaskPayload } from "./task";
import { Vehicle, VehiclePayload } from "./vehicle";

export enum RoutingType {
  RouteSequential = "ROUTE_SEQUENTIAL",
  PickupAndDelivery = "PICKUP_AND_DELIVERY",
}

export enum OptimizationType {
  MinDistance = "MIN_DISTANCE",
  TimeEqual = "TIME_EQUAL",
  TaskEqual = "TASK_EQUAL",
}

export interface RoutingRequest {
  targetDate: string;
  routingType: RoutingType;
  optimizationType: OptimizationType;
  vehicles: Vehicle[];
  tasks: Task[];
}

export interface RoutingPayload {
  targetDate: Date;
  routingType: RoutingType;
  optimizationType: OptimizationType;
  vehicles: VehiclePayload[];
  tasks: TaskPayload[];
}
